import React, { useEffect, useState } from "react";
import {
  SmartFormInterFace,
  SmartTable,
  SmartTableNewInterface,
} from "soft_digi";
import { RATINGS_URLS, REPORT_URLS, SESSION_URLS } from "../../api/AdminUrls";
import { get, post } from "../../services/smartApiService";
import { SdsFsDownloadFile } from "soft_digi/dist/services/FileService";
import { useSiteContext } from "../../contexts/SiteProvider";
import TraineeReport from "../sessions/TraineeReport";

interface HeaderProps {}
const Ratings: React.FC<HeaderProps> = () => {
  const [tabData, setTabData] = useState([]);
  const { openModal, closeModal, setTitle } = useSiteContext();
  // const { setTitle } = useSiteContext();
  useEffect(() => {
    setTitle("Ratings");
  }, []);

  const loadTableData = () => {
    let URL = RATINGS_URLS.GET_ALL;
    // console.log("ratign all ", URL);
    const subscription = post(URL, {}).subscribe((response) => {
      setTabData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
  }, []);

  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },

    {
      title: "Loco Pilot Name",
      index: "ename",
    },

    {
      title: "Session ID",
      index: "session_id",
    },
    {
      title: "content(theory)",
      index: "theory",   
    },
    // {
    //   title: "content(practice)",
    //   index: "practical",
    // },
    {
      title: "Assessment",
      index: "assessment",
    },
    { title: "Overall", index: "overall" },
    // {
    //   title: "Status",
    //   index: "status",
    // },
  ];

  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-7",
      custom: <p className="is-size-4 has-text-weight-bold">Ratings</p>,
    },

    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: [
        // {
        //   type: "EXPORT",
        //   className: "smart-third-button",
        //   // label:"",
        //   // icon:""
        // },
        // {
        //   type: "COLUMN-FILTER",
        //   label: "EX",
        //   className: "sd-table-export",
        // },
      ],
    },
    {
      type: "SEARCH",
      widthClass: "is-3",
      align: "JUSTIFY",
    },
  ];

  return (
    <>
      <div className="sd-efl-input">
        <SmartTable
          columns={columns}
          data={tabData}
          tableTop={tableTop}
          tableProps={{
            className: "is-hoverable is-bordered smart-hims-table",
            isResponsive: true,
            searchPlaceHolder: "Search",
          }}
          allowColumnSection={true}
          // paginationProps={{
          //   pageSize: 10,
          // }}
        />
      </div>
    </>
  );
};

export default Ratings;
